module.exports = __webpack_public_path__ + "img/Tile_Roof.b8f17b34.jpg";